export default {
  applicationCredit: {
    search: {
      businessDepartment: '事业部门',
      businessDepartmentPlaceholder: '请选择事业部门',
      partnerName: '合作伙伴名称/编码',
      partnerNamePlaceholder: '请输入合作伙伴名称/编码',
      enterpriseProperty: '企业类型',
      enterprisePropertyPlaceholder: '请选择企业类型',
      requestStatus: '申请单状态',
      requestStatusPlaceholder: '请选择申请单状态',
      requestDateStart: '申请日期从',
      requestDateStartPlaceholder: '请选择申请日期从',
      requestDateEnd: '申请日期到',
      requestDateEndPlaceholder: '请选择申请日期到',
      creditType: '授信类型',
      creditTypePlaceholder: '请选择授信类型',
      accountsType: '账款类型',
      accountsTypePlaceholder: '请选择账款类型',
    },
    table: {
      creditRequestNo: '申请单号',
      departmentCode: '事业部门',
      contractNo: '合同号',
      requestDate: '申请时间',
      requestPerson: '申请人',
      partnerName: '合作伙伴名称',
      creditCode: '统一社会信用代码',
      accountType: '账款类型',
      creditType: '授信类型',
      requestAmount: '申请额度(元)',
      requestAmountTable: '信用额度(元)',
      requestStatus: '单据状态',
      validDate: '有效期从',
      invalidDate: '有效期到',
      basicCurrencyType: '币别',
      createPersonName: '创建人',
      lastYearFinanceMark: '备注',
    },
    form: {
      info: '基本信息',
      creditRequestNo: '申请单号',
      creditRequestNoPlaceholder: '系统自动生成',
      businessDepartment: '事业部门',
      businessDepartmentPlaceholder: '请选择事业部门',
      requestPerson: '申请人',
      requestPersonPlaceholder: '请输入申请人',
      requestDate: '申请时间',
      requestDatePlaceholder: '请选择申请时间',
      partnerNo: '合作伙伴编码',
      partnerNoPlaceholder: '请选择合作伙伴编码',
      partnerName: '合作伙伴名称',
      partnerNamePlaceholder: '请选择合作伙伴名称',
      creditCode: '统一社会信用代码',
      creditCodePlaceholder: '请输入统一社会信用代码',
      legalPerson: '法定代表人',
      legalPersonPlaceholder: '请输入法定代表人',
      registeredAssets: '注册资本(元)',
      registeredAssetsPlaceholder: '请输入注册资本',
      actualAssets: '实收资本(元)',
      actualAssetsPlaceholder: '请输入实收资本',
      basicCurrencyType: '币别',
      basicCurrencyTypePlaceholder: '请选择币别',
      establishedDate: '成立日期',
      establishedDatePlaceholder: '请选择成立日期',
      enterpriseType: '企业类型',
      enterpriseTypePlaceholder: '请选择企业类型',
      streetAddress: '注册地址',
      streetAddressPlaceholder: '请输入注册地址',
      officeAddress: '办公地址',
      officeAddressPlaceholder: '请输入办公地址',
      accountInfo: '额度信息',
      accountType: '账款类型',
      accountTypePlaceholder: '请选择账款类型',
      creditType: '授信类型',
      creditTypePlaceholder: '请选择授信类型',
      referenceContractNo: '关联合同号',
      referenceContractNoPlaceholder: '请输入关联合同号',
      isInsure: '是否投保',
      isInsurePlaceholder: '请选择是否投保',
      insureAmount: '保险批复额度(元)',
      insureAmountPlaceholder: '请输入保险批复额度',
      requestAmount: '申请金额(元)',
      requestAmountPlaceholder: '请输入申请金额',
      amountCurrencyType: '额度币别',
      amountCurrencyTypePlaceholder: '请选择额度币别',
      requestPaymentDays: '申请账期(天)',
      requestPaymentDaysPlaceholder: '请输入申请账期',
      validDate: '有效期从',
      validDatePlaceholder: '请选择有效期从',
      invalidDate: '有效期到',
      invalidDatePlaceholder: '请选择有效期止',
      financeCurrencyType: '财务币别',
      financeCurrencyTypePlaceholder: '请选择财务币别',
      sellsRevenueInfo: '上一年度主要财务数据',
      sellsRevenue: '销售收入(元)',
      sellsRevenuePlaceholder: '请输入销售收入',
      profit: '利润(元)',
      profitPlaceholder: '请输入利润',
      totalAssets: '资产总额(元)',
      totalAssetsPlaceholder: '请输入资产总额',
      totalDebt: '负债总额(元)',
      totalDebtPlaceholder: '请输入负债总额',
      totalPureAssets: '净资产总额(元)',
      totalPureAssetsPlaceholder: '请输入净资产总额',
      lastYearFinanceMark: '备注',
      lastYearFinanceMarkPlaceholder: '请输入信息',
      enterpriseInfo: '企业基本情况',
      shareholderStructure: '股东结构',
      shareholderStructurePlaceholder: '请输入股东结构',
      enterpriseProperty: '企业性质',
      enterprisePropertyPlaceholder: '请选择企业性质',
      upstreamAndPaymentPlaceholder: '请输入信息',
      downstreamAndPayment: '主要下游客户及结算方式',
      assetType: '资产类别（海宁）',
      assetTypePlaceholder: '请选择资产类别',
      assetTypeDesc: '资产类别描述',
      assetTypeDescPlaceholder: '请输入资产类别描述',
      tradingModel: '主要交易模式',
      tradingModelPlaceholder: '请输入信息',
      businessRiskJudgement: '业务风险判断',
      businessRiskJudgementPlaceholder: '请输入信息',
      enterpriseOther: '其他',
      enterpriseOtherPlaceholder: '请输入信息',
      requestReason: '申请原因',
      requestReasonPlaceholder: '请输入申请原因',
      attachmentList: '申请单附件上传',
      attachmentListForm: {
        attachmentName: '附件名称',
        uploader: '上传人',
        uploadData: '上传日期',
      },
      riskManageInfo: '风控复核信息',
      upstreamAndPayment: '主要上游供应商及结算方式',
      isInformationMatch: '申报工商信息与查询是否相符',
      hasPoorCredit: '是否有失信被执行人情况',
      firstTradeDate: '最早交易时间',
      totalTradeTimes: '总交易次数',
      lastRequestAmount: '过往授信额度',
      lastRequestPaymentDays: '过往授信账期',
      isOvertimeAgreement: '是否有逾期履约',
      cooperationAmount: '本年合作金额',
      majorLawsuits: '重大涉诉情况',
      riskManageOther: '其他',
    },
    msg: {
      noSelectDel: '请选择一条申请单进行操作',
      noSelectEdit: '您还没选择要修改的申请单',
      onlyCanSelectNoEdit: '只能选择一条申请单进行修改',
      typeSelectEdit: '只有已保存和已驳回状态可以修改',
      typeSelectDel: '只有已保存和已驳回状态可以删除',
      checkText: '长度在 1 到 40 个字符',
      yes: '是',
      no: '否',
      all: '全部',
      userAcct: '用户账号',
      siri: '上海思芮有限公司',
      newCreditApplication: '信用额度申请单新增',
      applicationCreditAdd: '信用额度申请单新增',
      applicationCreditEdit: '信用额度申请单修改',
      listCreditRequests: '信用额度申请单列表',
      notSelectedModify: '您还没选择要修改的数据',
      delSelectedModify: '您还没选择要删除的数据',
      creditModification: '信用额度修改',
      newCredit: '信用额度新增',
      startUse: '启用',
      disable: '禁用',
      RMB: '人民币',
      errText: '我是错误信息',
      delMessage: '审批中和已生效的数据不能删除',
    },
  },
};
